import serviceUrls from 'src/constants/serviceUrls';
import axiosRequest from 'src/helpers/axiosRequest';

export function fetchConsentsByDefKey(consentDefKey) {
  const payload = {
    consentDefinitionKey: consentDefKey,
  };
  return axiosRequest('post', serviceUrls.CONSENT_GET_BY_DEF_KEY, payload);
}

export function saveConsentAcceptances(acceptedConsents) {
  let pad = v => {
    return v < 10 ? '0' + v : v;
  };
  let dt = new Date();
  let dtStr = dt.getFullYear() + '-' + pad(dt.getMonth() + 1) + '-' + pad(dt.getDate());
  const payload = {
    consentList: acceptedConsents,
    date: dtStr,
  };
  return axiosRequest('post', serviceUrls.CONSENT_SAVE_ACCEPTANCES, payload);
}

export function downloadSummary(payload) {
  return axiosRequest('post', serviceUrls.CONSENT_DOWNLOAD_SUMMARY, payload);
}



// WEBPACK FOOTER //
// ./src/services/consent.service.js